export default {
  oldPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 4,
    },
  },
  newPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 4,
    },
  },
};
